import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";

const config = firebase.initializeApp({
  apiKey: "AIzaSyCm278LWMixLPSeGYOSxaKuQx-zKlSrUyo",
  authDomain: "fir-82e9c.firebaseapp.com",
  databaseURL: "https://fir-82e9c.firebaseio.com",
  projectId: "fir-82e9c",
  storageBucket: "fir-82e9c.appspot.com",
  messagingSenderId: "372098598256",
  appId: "1:372098598256:web:715de839bb877364",
});
export const db = config.database();
export const auth = config.auth();
export const storage = config.storage();
export const conf = config;
